/**
 * @generated SignedSource<<2f84b3955a0681e1d1352fdb5e3bf686>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type RegisterInstrumentInstrumentQuery$variables = {
  referenceId: string;
};
export type RegisterInstrumentInstrumentQuery$data = {
  readonly manufacturedInstrumentByReference: {
    readonly instrumentId: string;
    readonly modelName: string;
    readonly serial: string | null | undefined;
    readonly uniqueCode: string;
  } | null | undefined;
};
export type RegisterInstrumentInstrumentQuery = {
  response: RegisterInstrumentInstrumentQuery$data;
  variables: RegisterInstrumentInstrumentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "referenceId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "referenceId",
    "variableName": "referenceId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instrumentId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serial",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modelName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uniqueCode",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RegisterInstrumentInstrumentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Instrument",
        "kind": "LinkedField",
        "name": "manufacturedInstrumentByReference",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RegisterInstrumentInstrumentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Instrument",
        "kind": "LinkedField",
        "name": "manufacturedInstrumentByReference",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "30877a9d982ad41515866a4e9062f763",
    "id": null,
    "metadata": {},
    "name": "RegisterInstrumentInstrumentQuery",
    "operationKind": "query",
    "text": "query RegisterInstrumentInstrumentQuery(\n  $referenceId: String!\n) {\n  manufacturedInstrumentByReference(referenceId: $referenceId) {\n    instrumentId\n    serial\n    modelName\n    uniqueCode\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2010839543a4ad57b8c99101b9ff941c";

export default node;
